import script from "./DowngradeSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./DowngradeSuccess.vue?vue&type=script&setup=true&lang=js"

import "./DowngradeSuccess.vue?vue&type=style&index=0&id=591fe6e5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591fe6e5"]])

export default __exports__